import React, { useEffect } from "react";
import { TicketContext } from "../../../tickets/_shared/context/TicketContext";
import { useTicketManager } from "../../fetching";

/**
 * Get the current ticket data from the context.
 * Throws an error if the hook is used outside of the TicketContextProvider.
 * @returns the context value
 */
export const useTicketData = (ticketId?: string) => {
  const ticketData = React.useContext(TicketContext);

  const ticketManager = useTicketManager({
    filters: {
      ticketId: {
        value: ticketId,
        attribute: "objectId",
      },
    },
  });

  useEffect(() => {
    if (!ticketId) return;
    const currentFilter = ticketManager.getFilter("ticketId");
    if (!currentFilter || currentFilter.value === ticketId) return;
    currentFilter.value = ticketId;
    ticketManager.fetchTickets();
  }, [ticketId]);

  if (!ticketData && !ticketId)
    throw new Error(
      "Do not use useTicketData outside of TicketContextProvider!"
    );

  if (ticketId) return ticketManager?.data?.[0];
  return ticketData;
};
